import { Button } from '@/ui/design-system/components/ui/button';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';
import { withMixpanelClick } from 'utils/app';

const TrackedSoftButtonInner = forwardRef(function TrackedSoftButtonInner(
    {
        IconLeft,
        IconRight,
        children,
        isDisabled,
        wrapText = false,
        fetching,
        mixpanelContext,
        className,
        ...props
    },
    ref,
) {
    return (
        <Button
            ref={ref}
            variant="ghost"
            size="default"
            disabled={!!isDisabled}
            loading={fetching}
            leftIcon={
                IconLeft ? (
                    <IconLeft className="!size-[1.2em] shrink-0 opacity-50" />
                ) : undefined
            }
            rightIcon={
                IconRight ? (
                    <IconRight className="!size-[1.2em] shrink-0 opacity-50" />
                ) : undefined
            }
            className={cn(wrapText && 'whitespace-normal', className)}
            {...props}
        >
            {children}
        </Button>
    );
});

const TrackedSoftButton = withMixpanelClick(
    TrackedSoftButtonInner,
    'SoftButton',
);

export default TrackedSoftButton;
